const routes = {
  stockMenu: "/stock-menu",
  quoteList: "/quote-list",
  newQuote: "/new-quote",
  newQuoteTireCar: "/new-quote-tire-car",
  masterManagement: "/master-management",
  mstStore: "/mst-store",
  mstTireWheelStore: "/mst-store/tire-wheel-store",
  mstWheelStore: "/mst-store/wheel-store",
  mstTireList: "/mst-store/tire-list",
  mstTireBrand: "/mst-store/tire-brand",
  mstUser: "/mst-user",
  mstClient: "/mst-client",
  mstShippingDest: "/mst-client/:id/mst-shipping-dest",
  mstProcFeeSetting: "/mst-proc-fee/setting",
  procFeeSetting: "/proc-fee/setting",
  itemPriceSetting: "/item-price/setting",
  mstItem: "/mst-item",
  mstItemEditPrice: "/mst-item/:id/edit-price",
  items: "/items",
  itemDetail: "/item/:itemId",
  itemRegister: "/item/:itemId/register",
  quotationDetail: "/quotation/:quotationId",
  orders: "/orders",
  orderProductList: "/order/products/:orderId",
  orderDetail: "/order/detail/:orderProductId",
  mstCarTireSizeSearch: "/mst-car-tiresize/search",
  mstCarModelSelection: "/mst-car-model/selection",
  mstCarModelTireWheelSelection: "/mst-car-model/tire-wheel-selection",
  mstCarModelProductCode: "/mst-car-model/product-code",
  mstCarWheelProductCode: "/mst-car-wheel/product-code",
  mstProcFee: "/mst-proc-fee",
  mstConfirmProcFee: "/mst-confirm-proc-fee",
  mstWheelTireProcFee: "/mst-wheel-tire-proc-fee",
  mstSelectedTireProcFee: "/mst-selected-tire-proc-fee",
  mstCarModelResult: "/mst-car-model/result",
  mstYhCompany: "/mst-yh-company",
  mstCategory: "/mst-category",
  mstVendor: "/mst-vendor",
  forbidden: "/forbidden",
  mst4BundlePriceTwSetSetting: "/mst-4bundle-price-twset/setting",
  mstCsv: "/mst-csv",
  mstWheelPriceSetting: "/mst-wheel-price/setting",
  mstWinterWheelPriceSetting: "/mst-wheel-price/winter-setting",
  mstWheelBrandList: "/mst-wheel/brand-list",
  mstWheel: "/mst-wheel",
  mstOption: "/mst-option",
  mstCarModelPdf: "/mst-car-model/:quotationId/result-pdf",
  mstWheelTireEstResultPdf: "/mst-wheel-tire-est-result-pdf/:quoteId",
  changePassword: "/change-password",
  resetPassword: "/reset-password",
  forgotPassword: "/forgot-password",
  changelog: "/changelog",
  updates: "/updates",
  quotation: "/quotation-qr/:quotationId",
  notFound: "/not-found",
  invalidRoute: '/404'
};

export default routes;
